export const CREATE_ORDER = '@@hfty-orders/CREATE_ORDER'
export const UPDATE_USER_BILLING_INFO = '@@hfty-orders/UPDATE_USER_BILLING_INFO'

